import { render, staticRenderFns } from "./GeneratedDocumentsMistakeModal.vue?vue&type=template&id=fce20b70&scoped=true&"
import script from "./GeneratedDocumentsMistakeModal.vue?vue&type=script&lang=js&"
export * from "./GeneratedDocumentsMistakeModal.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedDocumentsMistakeModal.vue?vue&type=style&index=0&id=fce20b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce20b70",
  null
  
)

export default component.exports